<template>
  <li class="certificate-template-preview">
    <div class="card rounded connected-card">
      <div class="p-3 d-flex justify-content-between align-items-center" style="background-color: #f8f9fa; border-top: 2px dashed #dee2e6;">
        <h5 class="mb-0" style="color: #6c757d;">
          <i class="uil-swatchbook mr-2"></i>{{ $t("general.cetificate_template") }}
        </h5>
      </div>

      <hr class="m-0" />
      <div class="course-card-body">
        <div class="uk-padding-small position-relative">
          <div class="form-group row mb-2">
            <div class="col-md-12">
              <label class="col-form-label" for="name">{{
                $t("general.template_choose")
              }}</label>
              <select
                v-if="templates"
                class="selectpicker2 mb-3"
                :value="formData.certificate_template_id"
                @change="handleTemplateChange($event.target.value)"
              >
                <option v-if="isEditMode" data-icon="uil-swatchbook" value="" selected>{{ $t('general.template_choose') }}</option>
                <option
                  data-icon="uil-swatchbook"
                  v-for="item in templates"
                  :key="item.id"
                  :value="item.id"
                  :selected="item.id == formData.certificate_template_id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="certificate-container position-relative">
            <div class="certificate template2">
              <div class="water-mark-overlay"></div>
              <div class="certificate-header">
                <img v-if="topCenterLogoLink" :src="topCenterLogoLink"
                     class="template-logo template-logo-top-center" alt="" />
              </div>
              <div class="certificate-body">
                <p class="certificate-title">
                  <strong>{egitim.adi}</strong>
                </p>
                <h1>{{ formData.name }}</h1>
                <p class="student-name">
                  <span>{{ $t("certification.mr") }}</span>
                  {k.adi} {k.soyadi}
                </p>
                <div class="certificate-content">
                  <div class="about-certificate">
                    <p>
                      {{ formData.text }}
                    </p>
                  </div>
                </div>
                <div class="certificate-footer">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <p>{{ formData.certifying_name }}</p>
                      <span>{{ formData.certifying_title }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <span v-if="selectedTemplate && isDateVisible(selectedTemplate.show_date)"
                    class="certificate-date">{tamamlanma.tarihi}</span>
              <img v-if="bottomLeftLogoLink" :src="bottomLeftLogoLink"
                   class="template-logo template-logo-bottom-left" alt="" />
            </div>
            <img v-if="coverImageLink" :src="coverImageLink" class="certificate-background-img" alt="" />
          </div>
        </div>
      </div>

      <div class="card-footer p-3" style="text-align: end">
        <button class="uk-button uk-button-primary small" type="button" @click="$emit('saveForm')">
          <i class="icon-feather-arrow-right"></i>
          {{ $t("general.save") }}
        </button>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "CertificateTemplatePreview",
  props: {
    formData: {
      type: Object,
      required: true
    },
    templates: {
      type: Array,
      default: () => []
    },
    company: {
      type: Object,
      default: () => ({})
    },
    coverImageLink: {
      type: String,
      default: null
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedTemplate() {
      return this.templates.find(item => item.id == this.formData.certificate_template_id) || null;
    },
    topCenterLogoLink() {
      if (this.selectedTemplate && this.selectedTemplate.top_center_logo_link) {
        return this.selectedTemplate.top_center_logo_link;
      }
      return this.company.logo_link || null;
    },
    bottomLeftLogoLink() {
      return this.selectedTemplate ? this.selectedTemplate.bottom_left_logo_link || null : null;
    }
  },
  methods: {
    isDateVisible(value) {
      return value === true || value === 1 || value === "1";
    },
    handleTemplateChange(value) {
      this.$emit('update:formData', { ...this.formData, certificate_template_id: parseInt(value) });
      this.$emit('changeCoverPicture');
    }
  },
  watch: {
    templates: function () {
      setTimeout(() => {
        if (window.$) {
          window.$(".selectpicker2").selectpicker();
        }
      }, 200);
    },
  }
};
</script>

<style scoped>
.certificate-background-img {
  top: 0px;
  height: 100%;
  width: 100%;
  left: 0px;
  bottom: 0px;
  right: 0px;
  position: absolute;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 1;
}

.certificate.template2::after {
  background-image: unset !important;
  background-color: transparent !important;
}

.certificate.template2 {
  z-index: 101;
  position: relative;
}

.template-logo {
  position: absolute;
  z-index: 3;
  object-fit: contain;
}

.certificate-header {
  position: relative;
  height: 90px;
}

.template-logo-top-center {
  top: 8px;
  left: 50%;
  width: 150px;
  height: 60px;
  transform: translateX(-50%);
}

.template-logo-bottom-left {
  left: 32px;
  bottom: 28px;
  width: 170px;
  height: 60px;
}

.certificate-date {
  position: absolute;
  right: 32px;
  bottom: 42px;
  z-index: 3;
  font-size: 16px;
}

.connected-card {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  margin-top: 0;
  border-top: none;
}
</style>
